<template>
  <section>
    <header-portal></header-portal>
    <template>
      <v-dialog v-model="dialogVisible" scrollable persistent max-width="750">
        <v-card>
          <v-card-title><v-icon large color="info">mail</v-icon><h4> Correo enviado correctamente</h4></v-card-title>
          <v-card-text>
            <h3>El correo fue enviado a <strong>{{this.formCorreo.correo1}}</strong> con un enlace</h3>
            <h3>por favor dirijase a su correo para continuar con el cambio de contraseña (también verificar en su bandeja de correo SPAN)</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialogVisible = false, $router.push('/')"><v-icon>check</v-icon>&nbsp;Entendido</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-tabs
        fixed-tabs
        centered
        icons-and-text
      >
<!--
        <v-tab>
          <v-icon color="primary">mail</v-icon> <p>Recuperar por Correo</p> 
        </v-tab>
-->
        <v-tab>
          <v-icon color="primary">list_alt</v-icon> <p>Recuperar por Formulario</p> 
        </v-tab>
<!--
        <v-tab-item>
           <div class="decretosBoton">
          <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small tile outline color="primary">
              <v-icon dark>keyboard_arrow_down</v-icon>Asistencia
              </v-btn>
          </template>
          <span> <div class="text-xs-justify">
              <p>Si Ud. registro su correo electrónico al momento de Crear la cuenta, siga los siguientes pasos: </p>
              <ul>
                <li>Digite su número de documento de identificación, fecha de nacimiento y su correo electrónico (el que registro AL MOMENTO DE CREAR SU CUENTA para la Declaración Jurada)</li>
                <li>Haga clic en "ENVIAR SOLICITUD" </li>
                <li>Siga las intrucciones que aparecerán en la pantalla. </li>
              </ul>
            </div></span>
        </v-tooltip>
        </div>
          <v-alert
          class="decretos"
            color="info"
            :value="true" >
            <div class="text-xs-justify">
              <p>Si Ud. registro su correo electrónico al momento de Crear la cuenta, siga los siguientes pasos: </p>
              <ul>
                <li>Digite su número de documento de identificación, fecha de nacimiento y su correo electrónico (el que registro AL MOMENTO DE CREAR SU CUENTA para la Declaración Jurada)</li>
                <li>Haga clic en "ENVIAR SOLICITUD" </li>
                <li>Siga las intrucciones que aparecerán en la pantalla. </li>
              </ul>
            </div>
          </v-alert>
          <v-card flat>
            <v-card-title><h4>Datos para recuperar contraseñas</h4></v-card-title>
            <v-card-text>
              <v-form v-model='valid' ref='form' lazy-validation>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md6 sm12 xs12>
                       <v-text-field
                          v-model="formCorreo.perdec_docidentidad"
                          maxlength='9'
                          label='Número de Documento de Identidad (sin guiones ni espacios)*'
                          prepend-icon="fingerprint"
                          :rules='nroDocumentoRules'
                          required
                       ></v-text-field>
                      </v-flex>
                      <v-flex md6 sm12 xs12>
                        <v-menu
                          v-model='menu'
                          :close-on-content-click='false'
                          :nudge-right='40'
                          lazy
                          transition='scale-transition'
                          offset-y
                          full-width
                          max-width='290px'
                          min-width='290px'
                        >
                          <template v-slot:activator='{ on }'>
                            <v-text-field
                              required
                              :rules='dateRules'
                              :value="formatDate(dateFormatted)"
                              v-model='dateFormatted'
                              @blur="date = parseDate(dateFormatted)"
                              label='Fecha de Nacimiento*'
                              hint='Formato DD/MM/AAAA'
                              v-mask="'##/##/####'"
                              persistent-hint
                              prepend-icon='event'
                              v-on='on'
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            no-title
                            v-model='date'
                            @input='menu = false'
                            locale="es-es"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-text-field
                      class="text-normal"
                      v-model="formCorreo.correo1"
                      label='Correo Electrónico registrado en su Declaración*'
                      required
                      :rules='dRulesCorreo'
                      prepend-icon="mail"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
                  <v-layout wrap>
                    <v-flex sm12 md12>
                       <v-subheader>
                        <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                       </v-subheader>
                    </v-flex>
                  </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
               <v-btn
                color="primary"
                @click="verificarDatosEnviarSolicitd(), loader = 'loadingButton'"
                :loading="loadingButton"
                :disabled="loadingButton"
                >
                  <template v-slot:loader>
                 <span>procesando..</span>
                  </template>
                ENVIAR SOLICITUD
              </v-btn>
              <v-btn
                color="error"
                :disabled="buttonCancel"
                @click="$router.push('/')">
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
-->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
         <v-stepper v-model="e13" vertical>
        <v-stepper-step :complete="e13 > 1" step="1" :editable="e13 !==3 && e13 !==2" @click="clearLoaders()">
          <h4><v-icon color="primary">person</v-icon> Datos Personales</h4>
        </v-stepper-step>
        <v-stepper-content step="1">
          <!-- inicio de paso 1 -->
           <div class="decretosBoton">
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span>Según el Art.3 D.S. 1233, la Declaración Jurada de Bienes y Rentas es la obligación de toda servidora y servidor público de prestar declaración sobre los bienes, deudas y rentas que tiene antes durante y después del ejercicio a cargo. Por tanto llene correctamente sus datos en el formulario, caso contrario se seguirá las medidas legales correspondientes según el Art. 15 (Responsabilidades por Incumplimiento a la Presentación Oportuna de la DJBR.)</span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
          <v-alert
          class="decretos"
           align='justify'
            :value="true"
            type="info"
            outline
          >  Según el Art.3 D.S. 1233, la Declaración Jurada de Bienes y Rentas es la obligación de toda servidora y servidor público de prestar declaración sobre los bienes, deudas y rentas que tiene antes durante y después del ejercicio a cargo. Por tanto llene correctamente sus datos en el formulario, caso contrario se seguirá las medidas legales correspondientes según el Art. 15 (Responsabilidades por Incumplimiento a la Presentación Oportuna de la DJBR.) 
          </v-alert>
           <v-card>
            <v-card-text>
              <v-form v-model='valid' ref='formPersonales' lazy-validation>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                        <v-select
                          :no-data-text="$t('comun.sin_datos')"
                          v-model="formRec.tipdoc_codigo"
                          :items="itemsTipoDocumentoIdentidad"
                          item-text='tipo_documento'
                          item-value='tipo_documento_codigo'
                          label='Tipo de Documento*'
                          :rules='dRules'
                          required
                          prepend-icon="credit_card"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  </v-layout>
              <v-layout row wrap v-if="formRec.tipdoc_codigo === '1'">
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md8 xs12>
                       <v-text-field
                         v-model="formRec.numero_docidentidad"
                         label='Número de Cédula de Identidad*'
                         :rules='ciRules'
                         maxlength='9'
                         prepend-icon="fingerprint"
                       ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="formRec.sufijo_docidentidad"
                          label='Complemento SEGIP'
                          :rules='complementoRules'
                          maxlength='2'
                          prepend-icon="fingerprint"
                          class="text-normal"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="formRec.tipdoc_codigo === '3'">
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md12 xs12>
                        <v-text-field
                          v-model="formRec.prefijo_docidentidad"
                          label='Prefijo Pasaporte'
                          :rules="textAreaRules"
                          maxlength='5'
                          prepend-icon="keyboard_arrow_left"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md12 xs12>
                        <v-text-field
                          v-model="formRec.numero_docidentidad"
                          label='Valor Númerico de Pasaporte*'
                          maxlength='9'
                          :rules='ciRules'
                          required
                          prepend-icon="fingerprint"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md12 xs12>
                        <v-text-field
                          v-model="formRec.sufijo_docidentidad"
                          label='Sufijo Pasaporte'
                          :rules="textAreaRules"
                          maxlength='5'
                          prepend-icon="keyboard_arrow_right"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                       <v-text-field
                         v-model="formRec.perdec_appaterno"
                         label='Apellido Paterno'
                         :rules="textAreaRules"
                         maxlength='100'
                         prepend-icon="edit"
                       ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-text-field
                          v-model="formRec.perdec_apmaterno"
                          label='Apellido Materno'
                          :rules="textAreaRules"
                          maxlength='100'
                          prepend-icon="edit"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-text-field
                      v-model="formRec.perdec_nombres"
                      label='Nombres*'
                      maxlength='100'
                      :rules="textRules"
                      prepend-icon="edit"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                 <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                       <v-select
                          :no-data-text="$t('comun.sin_datos')"
                          v-model='formRec.perdec_genero'
                          :items='itemsGenero'
                          item-text='tipo_genero'
                          item-value='tipo_genero_codigo'
                          label='Genero*'
                          :rules='dRules'
                          required
                          persistent-hint
                          prepend-icon="wc"
                        ></v-select>
                      </v-flex>
                      <v-flex md6 xs12>
                        <global-date-input-picker
                          v-model="dateFecha" :hint="'Formato DD/MM/AAAA'" :rules="dateRules" label="Fecha de Nacimiento*">
                        </global-date-input-picker> 
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>    
             </v-form> 
               <v-layout wrap>
                    <v-flex sm12 md12>
                       <v-subheader>
                        <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                       </v-subheader>
                    </v-flex>
                  </v-layout>       
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
               <v-btn
                color="primary"
                @click="actualizaDatosPersonales(), loader = 'loadingButton'"
                :loading="loadingButton"
                :disabled="loadingButton"
                >
                <v-icon>arrow_forward_ios</v-icon>&nbsp;Siguiente
                  <template v-slot:loader>
                 <span>procesando..</span>
                  </template>
              </v-btn>
              <v-btn
                color="error"
                :disabled="buttonCancel"
                @click="$router.push('/')">
                <v-icon>cancel</v-icon>&nbsp;Cancelar
              </v-btn>
            </v-card-actions>
           </v-card>
           <!-- fin de paso 1 -->
           </v-stepper-content>
      <v-stepper-step  :complete="e13 > 2" step="2" :editable='false'>
          <h4><v-icon color="primary">credit_card</v-icon>  Datos de la Última Declaración Jurada de Bienes y Rentas </h4>
        </v-stepper-step>
        <v-stepper-content step="2">
           <div class="decretosBoton">
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span>Ya existe una cuenta o tarjeta con los datos personales digitados, porfavor registre su Última Declaración Jurada de Bienes y Rentas</span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
          <v-alert
          class="decretos"
            color="info"
            :value="true" >
            <div class="text-xs-justify">
               <p>Ya existe una cuenta o tarjeta con los datos personales digitados, porfavor registre su Última Declaración Jurada de Bienes y Rentas</p>
            </div>
          </v-alert>
          <!-- inicio de paso 2 -->
          <v-card>
            <v-card-text>
              <v-form v-model='valid' ref='formDeclaracion' lazy-validation>   
                <v-layout row wrap>
                  <v-flex md6 offset-md2>
                    <v-text-field
                      style="font-size: 20px;"
                      v-model="cod_control_cge"
                      label='Código de Control CGE*'
                      maxlength='15'
                      :rules='textRules'
                      prepend-icon="edit"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md6 offset-md2>
                    <v-text-field
                      style="font-size: 20px;"
                      v-model="numero_certificado"
                      label='Número de Certificado*'
                      maxlength='15'
                      :rules='textRules'
                      prepend-icon="edit"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                 <v-layout row wrap>
                  <v-flex md6 offset-md2>
                    <v-text-field
                      style="font-size: 20px;"
                      v-model="codigo_recepcion"
                      label='Código de Recepción*'
                      maxlength='15'
                      :rules='textRules'
                      prepend-icon="edit"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md6 offset-md2>
                    <global-date-input-picker
                      v-model="dateRecepcion" :hint="'Formato DD/MM/AAAA'" :rules="dateRules" label="Fecha de Recepción*">
                    </global-date-input-picker>
                      </v-flex>
                </v-layout>
              </v-form>
                <v-layout wrap>
                    <v-flex sm12 md12>
                       <v-subheader>
                        <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                       </v-subheader>
                    </v-flex>
                  </v-layout>
            </v-card-text>
             <v-card-actions>
              <v-spacer></v-spacer>
               <v-btn
                color="primary"
                @click="actualizaDatosFormulario(), loader = 'loadingButton'"
                :loading="loadingButton"
                :disabled="loadingButton"
                >
                <v-icon>arrow_forward_ios</v-icon>&nbsp;Siguiente
                  <template v-slot:loader>
                 <span>procesando..</span>
                  </template>
              </v-btn>
            </v-card-actions>
          </v-card>
                    <!-- fin de paso 2 -->
        </v-stepper-content>
        <v-stepper-step  :complete="e13 > 3" step="3" :editable='false'>
          <h4><v-icon color="primary">done_all</v-icon> Datos de la Cuenta a Recuperar</h4>
        </v-stepper-step>
        <v-stepper-content step="3">
          <!-- inicio de paso 3 -->
          <v-card>
            <v-card-text>
                <div class="decretosBoton">
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span>Digite su contraseña, por seguridad debe ser mayor a 8 caracteres, contener letras y números (A-Z, 0 - 9) y al menos un caracter especial.
              Por ejemplo: "@ # % &". Resguarde su contraseña para evitar fraudes y no ser sancionado según el D.S. N° 1233</span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
            <v-alert align='justify'
            class="decretos"
            :value="true"
            type="info"
            outline
          > Digite su contraseña, por seguridad debe ser mayor a 8 caracteres, contener letras y números (A-Z, 0 - 9) y al menos un caracter especial.
          Por ejemplo: "@ # % &". Resguarde su contraseña para evitar fraudes y no ser sancionado según el D.S. N° 1233
          </v-alert>
          <v-form v-model='valid' ref='formRecupera' lazy-validation>   
                <v-layout row wrap>
                  <v-flex md6 offset-md2>
                    <v-text-field
                      style="font-size: 20px;"
                      v-model="formRec.cuenta_usuario"
                      label='Cuenta de Usuario'
                      :disabled="true"
                      :rules='dRules'
                      prepend-icon="edit"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md6 offset-md2>
                    <v-text-field
                      style="font-size: 20px;"
                      v-model="contrasenia"
                      class="text-normal"
                      label='Contraseña*'
                      :rules='passRule'
                      required
                      type='password'
                      prepend-icon="security"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md6 offset-md2>
                    <v-text-field
                      style="font-size: 20px;"
                      v-model="contrasenia_repetir"
                      class="text-normal"
                      label='Repetir Contraseña*'
                      :rules='passRule'
                      required
                      type='password'
                      prepend-icon="security"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
          </v-form>  
            <v-layout wrap>
                    <v-flex sm12 md12>
                       <v-subheader>
                        <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                       </v-subheader>
                    </v-flex>
                  </v-layout>  
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
               <v-btn
                color="primary"
                @click="actualizaContrasenia(), loader = 'loadingButton'"
                :loading="loadingButton"
                :disabled="loadingButton"
                >
                <v-icon>save</v-icon>&nbsp;Guardar
                  <template v-slot:loader>
                 <span>procesando..</span>
                  </template>
              </v-btn>
            </v-card-actions>
          </v-card>
           <!-- fin de paso 3 -->
        </v-stepper-content>
      </v-stepper>
            <v-dialog v-model="dialogForm" scrollable persistent max-width="750">
        <v-card>
          <v-card-title><v-icon large color="info">done_all</v-icon> <h4> Contraseña cambiada correctamente.</h4></v-card-title>
          <v-card-text>
            <h3>Se cambio la contraseña de la cuenta <strong>{{this.formRec.cuenta_usuario}} </strong> que pertenece a <strong> {{this.formRec.perdec_nombres.toUpperCase() }} 
              {{ this.formRec.perdec_appaterno.toUpperCase() }}  {{ this.formRec.perdec_apmaterno.toUpperCase() }}</strong> </h3>
            <h3><b>Favor tomar nota de la cuenta y la contraseña</b></h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
                       <v-btn color="primary" v-show="this.salir" @click="$router.push('/')"><v-icon>check</v-icon>&nbsp;Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </template>
  </section>
</template>
<script>
import HeaderPortal from '@/components/djbrd/headerPortal.vue';
import Cuentas from '../mixins/cuentas.js';

export default {
  mixins: [ Cuentas ],
  components: {
    HeaderPortal
  },
  created () {
  },
  data: () => ({
    e13: 1,
    tipoNacionalidad: '1',
    formCorreo: {
      perdec_docidentidad: '',
      correo1: '',
      perdec_fecha_nacimiento: ''
    },
    formRec: { // array para recuperar por formulario
      tipdoc_codigo: '',
      prefijo_docidentidad: '',
      numero_docidentidad: '',
      sufijo_docidentidad: '',
      perdec_appaterno: '',
      perdec_apmaterno: '',
      perdec_nombres: '',
      perdec_fecha_nacimiento: null, // fecha de nacimiento por recuperacion por formulario
      perdec_genero: '',
      perdec_codigo: '',
      cuenta_usuario: ''
    },
    itemsTipoDocumentoIdentidad: [
      {
        tipo_documento: 'Cédula de Identidad',
        tipo_documento_codigo: '1'
      },
      {
        tipo_documento: 'Pasaporte',
        tipo_documento_codigo: '3'
      }
    ],
    itemsGenero: [
      {
        tipo_genero: 'FEMENINO',
        tipo_genero_codigo: '0'
      },
      {
        tipo_genero: 'MASCULINO',
        tipo_genero_codigo: '1'
      }
    ],
    menu1: false,
    dateFecha: '', // fecha de nacimiento por recuperacion por formulario
    cod_control_cge: '',
    numero_certificado: '',
    codigo_recepcion: '',
    dateRecepcion: '',
    menu2: false,
    contrasenia: '',
    contrasenia_repetir: '',
    salir: false,
    dialogForm: false,
    // ///
    valid: true,
    correoOk: false,
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: '',
    menu: false,
    loader: null,
    loadingButton: false,
    buttonCancel: false,
    dialogVisible: false,
    dRules: [v => !!v || 'Este campo es requerido'],
    dRulesCorreo: [v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'El correo no tiene el formato correcto'],
    dateRules: [v => !!v || 'Este campo es requerido',
      v => (v && v.length <= 10) || 'El formato requerido DD/MM/AAAA sólo tiene 10 campos',
      v => (v && /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](18|19|20|21|22|23)\d\d$/.test(v)) || 'Fecha no válida'],
    passRule: [v => /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W_]){1,})(?!.*\s).{8,}$/.test(v) || 'Debe tener al menos 8 caracteres, una letra mayúscula (A-Z), minúscula (a-z), un número (0-9) y un caracter especial, por ejemplo ( @ # $ % ^ & * ç )'],
    nroDocumentoRules: [
      v => !!v || 'Nro de documento es requerido',
      v => /^[A-Za-z0-9]*$/.test(v) || 'El número de documento no es válido'
    ],
    complementoRules: [
      v => (!/^[CH]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[LP]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[CB]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[OR]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PT]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[TJ]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[SC]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[BN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición'
    ],
    ciRules: [
      v => !!v || 'El número de Documento es requerido',
      v => /^[0-9]*$/.test(v) || 'El número de Documento no es válido'
    ],
    textAreaRules: [v => v === '' ? true : /^[a-zA-Z0-9-_/.*'(),.;:=#°ñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜ \r\n]+$/.test(v) || 'Carácter especial no permitido'],
    textRules: [v => !!v || 'Este campo es requerido',
      v => /^[a-zA-Z0-9-_/.*'()"“”,.;:=#°ñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜÇç \r\n]+$/.test(v) || 'Carácter especial no permitido']
  }),
  methods: {
      // /////
    clearLoaders () {
      this.loader = null;
      this.loadingButton = false;
      this.buttonCancel = false;
    },
    actualizaDatosPersonales () {
      if (this.formRec.sufijo_docidentidad === 'lp' || this.formRec.sufijo_docidentidad === 'cb' || this.formRec.sufijo_docidentidad === 'sc' ||
          this.formRec.sufijo_docidentidad === 'pt' || this.formRec.sufijo_docidentidad === 'or' || this.formRec.sufijo_docidentidad === 'ch' ||
          this.formRec.sufijo_docidentidad === 'tj' || this.formRec.sufijo_docidentidad === 'bn' || this.formRec.sufijo_docidentidad === 'pn') {
        this.$message['warning']('El complemento no es un departamento de expedición por ejemplo 1234567-1j');
        this.form.sufijo_docidentidad = '';
      }
      if (!(!!this.formRec.perdec_apmaterno || !!this.formRec.perdec_appaterno)) {
        this.$message['warning']('Al menos uno de los apellidos es requerido');
      }
      if (this.$refs.formPersonales.validate() && (!!this.formRec.perdec_apmaterno || !!this.formRec.perdec_appaterno)) {
        this.buttonCancel = !this.buttonCancel;
        this.loadingButton = true;
        let paramsVerificar = {
          prefijo_docidentidad: this.formRec.prefijo_docidentidad,
          numero_docidentidad: this.formRec.numero_docidentidad,
          sufijo_docidentidad: this.formRec.sufijo_docidentidad,
          tipdoc_codigo: this.formRec.tipdoc_codigo,
          perdec_fecha_nacimiento: this.dateFecha,
          perdec_appaterno: this.formRec.perdec_appaterno,
          perdec_apmaterno: this.formRec.perdec_apmaterno,
          perdec_nombres: this.formRec.perdec_nombres
        };
        this.$storage.set('token', process.env.TOKEN_EXTERNO);
        this.$service.post(`control_tarjeta/verifica_persona_recovery`, paramsVerificar)
        .then(response => {
          this.$storage.remove('token');
          if (response.err_existente === 0) {
            this.formRec.perdec_codigo = response.inf_codigo;
            if (this.formRec.perdec_codigo === '' || this.formRec.perdec_codigo === null) {
              this.loadingButton = false;
              this.buttonCancel = false;
              this.$message['warning']('No se recupero bien los datos favor volver a intentar');
            } else {
              this.$message['success'](response.err_mensaje);
              this.e13 = 2;
              this.loadingButton = false;
              this.buttonCancel = false;
            }
          }
        }).catch(err => {
          this.$storage.remove('token');
          console.log(err);
          this.loadingButton = false;
          this.buttonCancel = false;
        });
        this.$storage.remove('token');
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos..');
      }
    },
    actualizaDatosFormulario () {
      if (this.$refs.formDeclaracion.validate()) {
        this.buttonCancel = !this.buttonCancel;
        this.loadingButton = true;
        let paramsVerificar = {
          perdec_codigo: this.formRec.perdec_codigo,
          control_cge: this.cod_control_cge,
          numero_certificado_departamental: this.numero_certificado,
          numero_certificado_nacional: this.codigo_recepcion,
          fecha_recepcion: this.dateRecepcion
        };
        this.$storage.set('token', process.env.TOKEN_EXTERNO);
        this.$service.post(`control_tarjeta/verifica_ultima_djbr`, paramsVerificar)
        .then(response => {
          this.$storage.remove('token');
          if (response.err_existente === 0) {
            this.$message['success'](response.err_mensaje);
            this.formRec.cuenta_usuario = response.inf_complemento;
            this.e13 = 3;
            this.loadingButton = false;
            this.buttonCancel = false;
          } else {
            this.$message['warning'](response[0].err_mensaje);
            this.loadingButton = false;
            this.buttonCancel = false;
          }
        }).catch(err => {
          this.$storage.remove('token');
          console.log(err);
          this.loadingButton = false;
          this.buttonCancel = false;
        });
        this.$storage.remove('token');
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos..');
      }
    },
    actualizaContrasenia () {
      if (this.$refs.formRecupera.validate()) {
        this.buttonCancel = !this.buttonCancel;
        this.loadingButton = true;
        let paramsVerificar = {
          perdec_codigo: this.formRec.perdec_codigo,
          cuefundec_contrasenia: this.contrasenia,
          cuefundec_contrasenia2: this.contrasenia_repetir
        };
        if (this.contrasenia === this.contrasenia_repetir) {
          this.$storage.set('token', process.env.TOKEN_EXTERNO);
          this.$service.put(`control_tarjeta/reset_password`, paramsVerificar)
          .then(response => {
            this.$storage.remove('token');
            if (response.err_existente === 0) {
              this.$message['success'](response.err_mensaje);
              this.loadingButton = false;
              this.buttonCancel = false;
              this.contrasenia = '';
              this.contrasenia_repetir = '';
              this.dialogForm = true;
              this.salir = true;
            }
          }).catch(err => {
            this.$storage.remove('token');
            console.log(err);
            this.loadingButton = false;
            this.buttonCancel = false;
          });
          this.$storage.remove('token');
        } else {
          this.$message['warning']('Las contraseñas no coinciden, favor validar');
          this.clearLoaders();
        }
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos..');
      }
    },
    verificarDatosEnviarSolicitd () {
      if (this.$refs.form.validate()) {
        this.buttonCancel = !this.buttonCancel;
        this.loadingButton = true;
        this.$storage.set('token', process.env.TOKEN_EXTERNO);
        this.$service.post(`control_tarjeta/reset_password_correo`, this.formCorreo)
        .then(response => {
          this.$storage.remove('token');
          if (response) {
            this.$message['success'](response);
            this.loadingButton = false;
            this.buttonCancel = false;
            this.dialogVisible = true;
          } else {
            this.loadingButton = false;
            this.buttonCancel = false;
          }
        }).catch(err => {
          this.$storage.remove('token');
          console.log(err);
          this.loadingButton = false;
          this.buttonCancel = false;
        });
        this.$storage.remove('token');
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos..');
      }
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    formatDateFecha (dateFecha) {
      if (!dateFecha) return null;
      const [year, month, day] = this.dateFecha.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDateFecha (dateFecha) {
      if (!dateFecha) return null;
      const [day, month, year] = dateFecha.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    formatDateRecepcion (dateRecepcion) {
      if (!dateRecepcion) return null;
      const [year, month, day] = this.dateRecepcion.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDateRecepcion (dateRecepcion) {
      if (!dateRecepcion) return null;
      const [day, month, year] = dateRecepcion.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  },
  computed: {
  },
  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date);
      this.formCorreo.perdec_fecha_nacimiento = this.dateFormatted;
    }
  }
};
</script>
<style lang="scss">
@import '../../admin/auth/login.scss';
</style>



// WEBPACK FOOTER //
// src/components/portal/login/RecuperarContrasenia.vue